import { Button, Dialog, Group, RemoveScroll } from '@mantine/core';
import type { FC, MouseEventHandler } from 'react';

type TCallDialog = {
	isCallDialogOpened: boolean;
	callDialogClose: () => void;
	handleOpenWebCall: MouseEventHandler<HTMLButtonElement>;
	uri: string;
};

const CallDialog: FC<TCallDialog> = ({
	isCallDialogOpened,
	callDialogClose,
	handleOpenWebCall,
	uri
}) => {
	return (
		<RemoveScroll enabled={isCallDialogOpened}>
			<Dialog
				onClose={callDialogClose}
				opened={isCallDialogOpened}
				position={{ top: '35%', left: '33%' }}
				radius="md"
				size="lg"
				withCloseButton
				zIndex="11111"
			>
				<Group className="flex flex-col p-6">
					<Button
						className="w-full"
						onClick={handleOpenWebCall}
					>
						Call inside App
					</Button>
					<Button
						className="w-full"
						component="a"
						href={uri}
						onClick={close}
					>
						Call via Device App
					</Button>
				</Group>
			</Dialog>
		</RemoveScroll>
	);
};

export default CallDialog;
